import {
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  BRIEF_NOTIFICATIONS_QUERY_KEY,
} from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBulkReachoutRequest } from "@shared/lib/types/pricingWorkload";
import { PricingWorkloadService } from "../services/PricingWorkload.service";

export function useBulkReachOut() {
  const {
    mutate: bulkReachOut,
    isLoading: isBulkReachOutLoading,
    isSuccess: isBulkReachOutSuccess,
  } = useMutation({
    mutationFn: (payload: IBulkReachoutRequest) =>
      PricingWorkloadService.bulkReachout(payload),
    onSuccess: (queryClient, _, { briefId }) => {
      ToastService.success("Bulk reachout sent successfully");
      queryClient.invalidateQueries({
        queryKey: BRIEF_NOTIFICATIONS_QUERY_KEY(briefId),
        refetchType: "all",
      });
      queryClient.invalidateQueries({
        queryKey: BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
        refetchType: "all",
      });
    },
    options: { skipInvalidation: true },
  });
  return { bulkReachOut, isBulkReachOutLoading, isBulkReachOutSuccess };
}
